module.exports = __webpack_public_path__ + "static/media/blueDownload.87db2a76.svg";